/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlaceDetails } from './PlaceDetails';
import {
    PlaceDetailsFromJSON,
    PlaceDetailsFromJSONTyped,
    PlaceDetailsToJSON,
    PlaceDetailsToJSONTyped,
} from './PlaceDetails';

/**
 * 
 * @export
 * @interface CitySearchResultDto
 */
export interface CitySearchResultDto {
    /**
     * 
     * @type {string}
     * @memberof CitySearchResultDto
     */
    name?: string | null;
    /**
     * 
     * @type {PlaceDetails}
     * @memberof CitySearchResultDto
     */
    placeDetails?: PlaceDetails;
}

/**
 * Check if a given object implements the CitySearchResultDto interface.
 */
export function instanceOfCitySearchResultDto(value: object): value is CitySearchResultDto {
    return true;
}

export function CitySearchResultDtoFromJSON(json: any): CitySearchResultDto {
    return CitySearchResultDtoFromJSONTyped(json, false);
}

export function CitySearchResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CitySearchResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'placeDetails': json['placeDetails'] == null ? undefined : PlaceDetailsFromJSON(json['placeDetails']),
    };
}

export function CitySearchResultDtoToJSON(json: any): CitySearchResultDto {
    return CitySearchResultDtoToJSONTyped(json, false);
}

export function CitySearchResultDtoToJSONTyped(value?: CitySearchResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'placeDetails': PlaceDetailsToJSON(value['placeDetails']),
    };
}

